export default "__VITE_ASSET__D_Kmy9Y0__"